module.exports = __webpack_public_path__ + "static/media/peer-abid.59d738c4.png";